import { WillWritingAdvice } from '@/app/will_writing_advice/entities/will-writing-advice.entity'

export interface WillWritingAdviceState {
    willWritingAdvices: WillWritingAdvice[]
}

export const state: WillWritingAdviceState = {
    willWritingAdvices: []
}
